// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__QqZOm","header":"PatientBlock_header__UoUxZ","label":"PatientBlock_label__3h9Xy","option":"PatientBlock_option__3hE5u"};